import React, { memo } from 'react';

import { clsx } from 'clsx';

import { usePersonalAccountFields } from '@shared/hooks/usePersonalAccountFields';
import { FieldLabels } from '@shared/types/enums/fieldLabels.enum';
import { Input } from '@shared/ui/Input';
import { VStack } from '@shared/ui/Stack';

import clsMain from '../Form/Form.module.scss';
import cls from './Address.module.scss';

type AddressProps = Pick<
  ReturnType<typeof usePersonalAccountFields>,
  | 'postalCode'
  | 'region'
  | 'city'
  | 'street'
  | 'houseNumber'
  | 'corpus'
  | 'building'
  | 'apartment'
  | 'floor'
  | 'comment'
  | 'errorPostalCode'
  | 'errorRegion'
  | 'errorCity'
  | 'errorHouseNumber'
  | 'errorStreet'
  | 'handleChangePostalCode'
  | 'handleChangeRegion'
  | 'handleChangeCity'
  | 'handleChangeStreet'
  | 'handleChangeHouseNumber'
  | 'handleChangeCorpus'
  | 'handleChangeBuilding'
  | 'handleChangeApartment'
  | 'handleChangeFloor'
  | 'handleChangeComment'
>;

export const Address = memo<AddressProps>(
  ({
    errorPostalCode,
    postalCode,
    handleChangePostalCode,
    region,
    errorRegion,
    handleChangeRegion,
    city,
    errorCity,
    handleChangeCity,
    street,
    errorStreet,
    handleChangeStreet,
    houseNumber,
    handleChangeHouseNumber,
    errorHouseNumber,
    corpus,
    handleChangeCorpus,
    building,
    handleChangeBuilding,
    apartment,
    handleChangeApartment,
    floor,
    handleChangeFloor,
    comment,
    handleChangeComment
  }) => (
    <div className={clsMain.plate}>
      <h2 className={clsMain.title}>Адрес доставки</h2>
      <VStack className={cls.addressInputWrapper}>
        <div className={cls.addressFirstLine}>
          <Input
            label={FieldLabels.POSTAL_CODE}
            isError={errorPostalCode}
            value={postalCode || ''}
            onChange={handleChangePostalCode}
          />
          <Input
            required
            label={FieldLabels.REGION}
            value={region || ''}
            isError={errorRegion}
            onChange={handleChangeRegion}
          />
        </div>
        <Input
          fullWidth
          required
          label={FieldLabels.CITY}
          value={city || ''}
          isError={errorCity}
          onChange={handleChangeCity}
        />

        <div className={clsx(cls.addressSecondLine, cls.inputLine)}>
          <Input
            required
            label={FieldLabels.STREET}
            value={street || ''}
            isError={errorStreet}
            onChange={handleChangeStreet}
          />
          <Input
            required
            label={FieldLabels.HOUSE_NUMBER}
            inputMode={'numeric'}
            value={houseNumber || ''}
            onChange={handleChangeHouseNumber}
            isError={errorHouseNumber}
          />
          <Input
            label={FieldLabels.CORPUS}
            inputMode={'numeric'}
            value={corpus || ''}
            onChange={handleChangeCorpus}
          />
          <Input
            inputMode={'numeric'}
            label={FieldLabels.BUILDING}
            value={building || ''}
            onChange={handleChangeBuilding}
          />
          <Input
            label={FieldLabels.APARTMENT}
            inputMode={'numeric'}
            value={apartment || ''}
            onChange={handleChangeApartment}
          />
          <Input
            label={FieldLabels.FLOOR}
            value={floor || ''}
            inputMode={'numeric'}
            onChange={handleChangeFloor}
          />
        </div>
        <Input
          fullWidth
          className={cls.commentInput}
          label={FieldLabels.COMMENT_ORDER}
          value={comment}
          onChange={handleChangeComment}
        />
      </VStack>
    </div>
  )
);
